/** The dashed placeholder shown where a table or list has no rows to draw. */
export default function EmptyState({ title, hint }: { title: string; hint?: string }) {
  return (
    <div className="flex flex-col items-center gap-2 rounded-xl border border-dashed border-hairline px-6 py-14 text-center">
      <span className="text-lg font-semibold">{title}</span>
      {hint && <span className="max-w-[46ch] text-base text-ink-muted">{hint}</span>}
    </div>
  );
}
